// ** React Imports
import React, { memo } from 'react';

// ** Third Party Imports
import { SkeletonLoading } from '@saleshandy/design-system';

// ** Type Imports
import { Iprops } from './type';

/**
 * @prop textEditorSkeletonsList = Takes array of rows that need to generate in skeleton
 * @description This component provides Skeleton of ai generating based on provided Array.
 * @returns React Compoent
 */
const TextEditorSkeleton: React.FC<Iprops> = memo(
  ({ textEditorSkeletonsList = [] }) => {
    if (textEditorSkeletonsList?.length === 0) {
      return <></>;
    }

    return (
      <div
        className="text-skeletons-container"
        style={{
          lineHeight: `${textEditorSkeletonsList?.[0]?.height || 12}px`,
        }}
      >
        {/* {textEditorSkeletonsList?.map((skeleton) => (
        <div
          key={`skeleton-${skeleton?.animationDelay || 0}`}
          className="custom-skeleton"
          style={{
            maxWidth: `${skeleton?.maxWidth || 100}%`,
            borderRadius: '4px',
            height: '12px',
            ...(skeleton?.background
              ? { background: `${skeleton?.background}` }
              : {}),
            ...(skeleton?.animationDelay
              ? {
                  animationDelay: `${skeleton?.animationDelay || 0}s`,
                }
              : {}),
          }}
        />
      ))} */}

        {textEditorSkeletonsList?.map((skeleton) => (
          <SkeletonLoading
            key={`skeleton-${skeleton?.animationDelay || 0}`}
            height={skeleton?.height || 12}
            enableAnimation
            width={`${skeleton?.maxWidth || 100}%`}
            style={{
              ...(skeleton?.background
                ? { background: `${skeleton?.background}` }
                : {}),
              ...(skeleton?.animationDelay
                ? {
                    animationDelay: `${skeleton?.animationDelay || 0}s`,
                  }
                : {}),
            }}
            {...(skeleton?.background
              ? { baseColor: 'transparent', highlightColor: 'transparent' }
              : {})}
            borderRadius={4}
          />
        ))}
      </div>
    );
  },
);
export default TextEditorSkeleton;
